import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { trim, values } from 'lodash';
import { APIService } from 'src/app/api.service';
import { DataService } from '../../services/data.service';
import { CommonService } from '../../services/common.service';
import { NavigationExtras, Router } from '@angular/router';
import { HttpUrlEncodingCodec } from '@angular/common/http';

@Component({
  selector: 'app-ledger-record-print',
  templateUrl: './ledger-record-print.component.html',
  styleUrls: ['./ledger-record-print.component.scss']
})
export class LedgerRecordPrintComponent implements OnInit {

  // @Input() LedgerRecordPrintData: any;
  ledgerid: any;
  modalReference: any;
  closeResult: string = '';
  ledgername: any;
  fromDate: any;
  toDate: any;
  opbal: any;
  colbal: any;
  period: any;

  ledger: any = [];
  ledgerList: any = [];
  templedgerList: any = [];
  agencyData: any = [];
  jarvisData: any = [];
  userList: any = [];
  data: any = [];
  voucher: any = [];
  ledgers: any = [];

  AgencyName: string = ''
  City: string = '';
  State: string = '';

  erpConfig: any = [];
  showColumn: any = {
    narration: false,
    cmnNotes: false
  }
  totalAmtDebit: number = 0;
  totalAmtCredit: number = 0;

  constructor(private appService: DataService, private apiService: APIService, 
    private router: Router, private commonFun: CommonService) { 
  }

  ngOnInit(): void {
   this.ledgerid = this.commonFun.GetParam("LID");
   this.fromDate = this.commonFun.GetParam("fdt");
   this.toDate = this.commonFun.GetParam("tdt");
   this.ledgername = decodeURIComponent(this.commonFun.GetParam("lname") + "");
   this.getData();
  }

  //total += parseFloat(String(arr1[i].CloBal).replace(/\,/g, "").replace(/\-/g, ""));

  getData() {
    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
      this.AgencyName = this.agencyData[0].AgencyName;
      this.City = this.agencyData[0].City;
      this.State = this.agencyData[0].State;
    }
    let userList = this.apiService.getCookie("J");
    if (userList) {
      this.userList = JSON.parse(userList);
    }
    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }
    let data = [{
      LedgerId: this.ledgerid,
      fromDT: this.fromDate,
      toDT:  this.toDate
    }];
    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: null,
      isWeb: true,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: 'get',
      moduleID: 2,
      data: JSON.stringify(data)
    }];

    this.apiService.getData(myParams, this.successResp.bind(this), this.failureResp.bind(this));

    let tmpData = this.apiService.getCookie("Ledger");

    if (tmpData) {
      this.ledgers = JSON.parse(tmpData);
    }

    this.getConfigData();
  }

printVoucherData(){
  setTimeout(function () {
    var printArea = $('#voucher').html();
    $('body').html(printArea); 
    window.print(); 
});
}

 //failureResp - failure handler
 failureResp(res: any) {
  if (res.error) {
  }
  else {
    alert(res.message);
  }
}
   //successResp - success  get handler
   successResp(res: any) {
    if (res.error) {
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData) {
          this.data = reponseData;
          if (this.data.Table[0].ErrCode == '1') {
            alert(this.data.Table[0].ErrMsg);
            return;
          }
          this.voucher = this.data.Table1;
          this.totalAmtDebit = 0;
          this.totalAmtCredit = 0;
          this.voucher.forEach((e: any) => {
            e.date = new Date(e.EffectiveDate);
            if(String(e.CloBal).indexOf('Cr') != -1){
              e.newCloBal = "-" + String(e.CloBal).replaceAll(' Cr', '').replaceAll(' Db', '').replaceAll(',', '');
            }
            else{
              e.newCloBal = String(e.CloBal).replaceAll(' Cr', '').replaceAll(' Db', '').replaceAll(',', '');
            }
            let tmpUser = this.userList.filter((x: any) => x.UserID == e.CreatedUserID);
            if (tmpUser.length > 0) {
              e.user = tmpUser[0].Name;
            }
            this.totalAmtCredit += Number(String(e.CrAmt).replace(/,/g, ''));
            this.totalAmtDebit += Number(String(e.DbAmt).replace(/,/g, ''));
          });
          //this.dataSource.data = this.voucher;
          this.opbal = this.voucher[0].CloBal;
          this.colbal = this.voucher[this.voucher.length - 1].CloBal;
          this.printVoucherData(); 
        }
      }
    }
  }

  getConfigData () {
    var erpConfigCookie = this.apiService.getCookie('ERP_Cfg');
    if (erpConfigCookie) {
      this.erpConfig = JSON.parse(erpConfigCookie);
      if (this.erpConfig && this.erpConfig.length > 0) {
        let ldgrRecordPrintPrefs = this.erpConfig[0]?.LdgrRcrdPrtPrefs ? this.erpConfig[0]?.LdgrRcrdPrtPrefs : '[]';
        if (ldgrRecordPrintPrefs) {
          ldgrRecordPrintPrefs = JSON.parse(ldgrRecordPrintPrefs);
          this.showColumn.narration = ldgrRecordPrintPrefs[0]?.Nrtn ? ldgrRecordPrintPrefs[0]?.Nrtn : false;
          this.showColumn.cmnNotes = ldgrRecordPrintPrefs[0]?.CmnNotes ? ldgrRecordPrintPrefs[0]?.CmnNotes : false;

        }
      }
    }
  }
}
